import { create } from "zustand";
import { authService } from "../services/auth";

export const useAuthStore = create((set) => ({
  user: null,
  token: localStorage.getItem("token"),
  isAuthenticated: !!localStorage.getItem("token"),
  login: async (email, password) => {
    const response = await authService.login(email, password);
    const { token, ...user } = response.data;
    localStorage.setItem("token", token);
    set({ user, token, isAuthenticated: true });
  },
  logout: async () => {
    await authService.logout();
    localStorage.removeItem("token");
    set({ user: null, token: null, isAuthenticated: false });
  },
  loadUser: async () => {
    try {
      const response = await authService.getMe();
      set({ user: response.data });
    } catch (error) {
      set({ user: null, isAuthenticated: false });
    }
  },
}));
